export class HrPerMovementInfoKey {
    private static readonly keyPrefix = 'hrPerMovementInfo';
    public static title = `${HrPerMovementInfoKey.keyPrefix}.title`;
    public static pageHeader = `${HrPerMovementInfoKey.keyPrefix}.pageHeader`;
    public static perPeopleStatus = `${HrPerMovementInfoKey.keyPrefix}.perPeopleStatus`;
}
